import { DEFAULT_CATEGORY_COLOR } from './categoryColors';

const HEX_COLOR_RE = /^#[0-9a-fA-F]{3,8}$/;

/**
 * Validates a CSS color value for safe interpolation into SVG attribute values
 * (both innerHTML string templates and dangerouslySetInnerHTML).
 *
 * Accepts:
 *   - Hex literals: `#RGB`, `#RGBA`, `#RRGGBB`, `#RRGGBBAA`
 *   - `currentColor` — the one CSS keyword the glyph components legitimately
 *     use as a default; it contains no characters that could break an SVG
 *     attribute.
 *
 * Anything else (e.g. `rgb(...)`, `red`, or an attacker-controlled
 * `"></rect><script>alert(1)</script>`) collapses to slate (`#76849A`) and
 * emits a dev warning.
 *
 * This is the shared boundary guard used by markerSvg.ts (innerHTML) and the
 * React glyph components (dangerouslySetInnerHTML). Callers that pass color
 * values into token-substituted SVG strings MUST run values through here first.
 */
export function sanitizeHexColor(input: string | undefined | null): string {
  if (typeof input === 'string') {
    if (HEX_COLOR_RE.test(input)) return input;
    if (input === 'currentColor') return input;
  }
  if (import.meta.env.DEV) {
    console.warn('[sanitizeHexColor] rejected unsafe color value, falling back to default:', input);
  }
  return DEFAULT_CATEGORY_COLOR;
}
